import { render, staticRenderFns } from "./PriceTiers.vue?vue&type=template&id=5ce2a745&scoped=true&"
import script from "./PriceTiers.vue?vue&type=script&lang=js&"
export * from "./PriceTiers.vue?vue&type=script&lang=js&"
import style0 from "./PriceTiers.vue?vue&type=style&index=0&id=5ce2a745&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2a745",
  null
  
)

component.options.__file = "PriceTiers.vue"
export default component.exports